import { render } from "./DeviceEditComponent.vue?vue&type=template&id=ecd46dce&scoped=true"
import script from "./DeviceEditComponent.vue?vue&type=script&lang=js"
export * from "./DeviceEditComponent.vue?vue&type=script&lang=js"

import "./DeviceEditComponent.vue?vue&type=style&index=0&id=ecd46dce&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecd46dce"]])

export default __exports__